import * as React from 'react';
import { connect } from 'react-redux';
import { find as _find } from 'lodash';
import { Modal, Button, Tooltip } from 'reactstrap';
import { setTimeout } from 'timers';
import { UserModel, marketDetails, CurrencyCodes, getPartDetail, PricingModel, getNestedPricingProp, PricingsModel } from 'franke-trough-dependencies';
import { DateRange } from 'react-date-range';
import { addDays } from 'date-fns';
import './Pricing.scss';
import { GlobalPrivateState, formatNumber, countriesSelectArray, SelectFieldModelOption, availableLanguages } from 'src/api';
import { Icon } from '../../Images';
import PricingsPeriodModal from './PricingsPeriodModal';
import { formatPeriod } from './Pricings';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { match as Match } from 'react-router';
import { PricingsDispatcher } from 'src/app/Container/Dispatcher/PricingsDispatcher';
import { PricingDispatcher } from 'src/app/Container/Dispatcher/PricingDispatcher';


export interface PricingsMarketProps {
  match: Match<{pricingId: string}>;
  pricing: GlobalPrivateState['pricing'];
  pricings: GlobalPrivateState['pricings'];
  isDisabled: boolean;
  dispatch: any;
}

export interface PricingsMarketState {
  isOpen: boolean; 
  key: string;
  hasChanged: boolean;
  showSaved: boolean;
  activeTab: string;
  pricing: PricingsModel;
  isEditingPeriod: boolean;
  selectedTimePeriod: any;
}

export class PricingsMarketPartial extends React.Component<PricingsMarketProps, PricingsMarketState> {
  constructor(props: PricingsMarketProps) {
    super(props);
    const partKeys = Object.keys(marketDetails);
    const initialItems: any = [];
  
    for (const partKey of partKeys) {
      const marketDetail = marketDetails[partKey];
      const initialValue = (marketDetail.type === 'float' || marketDetail.type === 'percentage' || marketDetail.type === 'price') ? formatNumber(0, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
      const item = {
        key: partKey,
        value: initialValue,
        countryCode: 'de'
      }
      initialItems.push(item);
    }

    const state: any = {
      key: 'selection',
      activeTab: 'general',
      pricing: {
        id: this.pricingId,
        dateFrom: null,
        dateUntil: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
        items: initialItems,
        termLinks: [],
        timePeriods: [],
      },
      selectedTimePeriod: null,
      hasChanged: false,
      showSaved: false
    };

    if (this.props.pricing && this.props.pricing.result && this.props.pricing.result.id === this.pricingId) {
      state.pricing = JSON.parse(JSON.stringify(this.props.pricing.result));
    } else if (this.props.pricings && this.props.pricings.result) {
      state.pricing = JSON.parse(JSON.stringify(this.props.pricings.result.find(p => p.id === this.pricingId)));
    }

    this.state = state;
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
    });
  }

  componentDidUpdate(prevProps: PricingsMarketProps) {
    const prevPricing = prevProps.pricing.result;
    const pricing = this.props.pricing.result;

    // console.log('pricing', prevPricing, prevState.pricing, this.props.pricing);

    // Finished updating/saving
    const pricingUpdated = this.state.pricing.dateFrom && prevProps.pricing.updating && !this.props.pricing.updating;
    const pricingSwitched = (pricing && pricing.id) && (prevPricing && prevPricing.id) && prevPricing.id !== pricing.id;
    if (pricingUpdated && !pricingSwitched) {
      this.setState({
        showSaved: true
      });

      setTimeout(() => {
        this.setState({
          showSaved: false
        });
      }, 4000);
    }
    
    const pricingsChanged = pricing && prevPricing !== pricing;
    if (pricingsChanged && pricing) {
      // We generate the pricing items from the part keys and markets... if we update these, we make sure that it reflects even with existing periods
      const mergedPricingItems = this.state.pricing.items;

      for (const item of mergedPricingItems) {
        const matchingItem = pricing.items && pricing.items.find((i: any) => i.key === item.key && i.groupKey === item.groupKey);
        
        if (matchingItem) {
          item.value = matchingItem.value;
        }
      }

      pricing.items = mergedPricingItems;

      this.setState({
        ...this.state,
        pricing
      });
    }
    
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true
      });
    }
  }

  public render() {
    const tabs = [
      { key: 'general', label: 'General values' },
      { key: 'timeDependent', label: 'Time-dependent' },
      { key: 'terms', label: 'Terms & Conditions' },
    ];

    console.log('raaa', this.state.pricing);

    return (
      <div className="partial-pricings-market">
        {(!this.props.pricings || !this.props.pricings.result) && (
          <PricingsDispatcher />
        )}
        {this.state.pricing.id && (
          <PricingDispatcher id={this.state.pricing.id} />
        )}
        <h2>Market details</h2>
        <div className="view-switcher">
          <div className="partial-pricing-switch-view">
            <ul className="list list-tabswitch list-unstyled d-flex">
              {tabs.map((tab) => (
                <li key={tab.key} className="d-inline-block">
                  <button
                    disabled={this.state.activeTab === tab.key}
                    className={`btn btn-link p-0 ${this.state.activeTab === tab.key ? 'active' : ''}`}
                    onClick={() => this.setState({ activeTab: tab.key })}
                    type="button"
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="modal-body">
          {this.renderPaneContent()}
        </div>
        
        {(this.state.isEditingPeriod) && (
          <PricingsPeriodModal 
            drilledSubmit={this.handlePeriodSubmit} 
            drilledClose={this.handlePeriodClose}
            selectedPricing={this.state.selectedTimePeriod}
            isDisabled={this.isDisabled} />
        )}

        <div className="pricings-list__cta">
          <Button className="btn" 
            onClick={() => this.handleSave()} 
            disabled={this.props.pricing.updating || !this.state.hasChanged} 
            id="pricings-list__cta-btn">
            <span className="btn-name">
              Save all changes
            </span>
          </Button>
          {this.state.showSaved && (
            <Tooltip
              autohide={false}
              isOpen={true}
              placement="top"
              target="pricings-list__cta-btn"
            >
              {this.props.pricing.error && (
                this.props.pricing.error.message
              ) || (
                <>Changes have been saved successfully</>
              )}
            </Tooltip>
          )}
        </div>
      </div>
    );
  }

  get isDisabled () {
    return this.props.pricings.updating && !this.props.pricings.loaded;
  }

  handlePeriodSubmit = (startDate: Date, endDate: Date) => {
    const { timePeriods, id } = this.state.pricing;
    const updatedTimePeriods = [...(timePeriods || [])];

    if (this.state.selectedTimePeriod) {
      const index = updatedTimePeriods.findIndex(tp => 
        tp.dateFrom === this.state.selectedTimePeriod.dateFrom && 
        tp.dateUntil === this.state.selectedTimePeriod.dateUntil
      );

      if (index !== -1) {
        updatedTimePeriods[index] = {
          ...updatedTimePeriods[index],
          dateFrom: startDate.toISOString(),
          dateUntil: endDate.toISOString()
        };
      }
    }

    this.setState({
      pricing: {
        ...this.state.pricing,
        timePeriods: updatedTimePeriods
      },
      isEditingPeriod: false,
      selectedTimePeriod: null,
      hasChanged: true
    });
  };

  handlePeriodClose = () => {
    this.setState({
      isEditingPeriod: false
    });
  }

  private renderPaneContent() {
    switch (this.state.activeTab) {
      case 'general':
        return this.renderGeneralValuesPane();
      case 'timeDependent':
        return this.renderTimeDependentPane();
      case 'terms':
        return this.renderTermsAndConditionsPane();
      default:
        return null;
    }
  }

  private renderGeneralValuesPane() {
    const { items } = this.state.pricing;
    // const { params } = this.props;
    const selectedCountry = items.find(i => i.key === 'country');
    const selectedCountryCode = selectedCountry && selectedCountry.value.toString() || 'de-DE';
    // const selectedCountryCodeHalf = selectedCountryCode.split('-')[0];

    const selectedCurrency = items.find(i => i.key === 'currency');
    const selectedCurrencyValue = selectedCurrency && selectedCurrency.value.toString() || 'EUR';

    const marketPricings = this.props.pricings.result && this.props.pricings.result.filter(pricing => pricing.type === 'market' && !pricing.deleted) || [];
    const marketPricingsCountries = getNestedPricingProp(marketPricings, 'country');

    return (
      <div className="pane-general">
        <ol className="pricings-list">
          {items && items.map((item: any, index: number) => {
            const name = getPartDetail(item.key, 'name', 'de', false, 'market');
            const description = getPartDetail(item.key, 'description', 'de', false, 'market');
            const type = getPartDetail(item.key, 'type', 'de', false, 'market');
            const defaultValue = getPartDetail(item.key, 'default', 'de', false, 'market') || '';
            const disabled = getPartDetail(item.key, 'disabled', 'de', false, 'market') || this.props.pricing.updating;
            const required = getPartDetail(item.key, 'required', 'de', false, 'market') || this.props.pricing.updating;
            let options: any = getPartDetail(item.key, 'options', 'de', false, 'market');

            if (options === 'countries') {
              options = countriesSelectArray();
              options = options.map((opt: SelectFieldModelOption) => {
                return {...opt, disabled: marketPricingsCountries.includes(opt.value as any) && opt.value !== selectedCountryCode}
              });
            }

            if (options === 'currencies') {
              const currencyCodeValues = Object.values(CurrencyCodes);
              options = currencyCodeValues.map(curr => {
                return {label: curr, value: curr}
              });
            }

            if (type === 'select' && options) {
              options = options.map((opt: any) => typeof opt === 'string' ? {value: opt, label: opt} : opt)
            }

            return (
              <li className="pricings-list__item" key={item.key+item.groupKey} title={item.key}>
                <span className="pricings-list__cell pricings-list__body">
                  {name}{required ? '\u00A0*' : ''}
                  <i>{description}</i>
                </span>
                <span className="pricings-list__cell pricings-list__price">
                  {(type === 'select') ? (
                    <select 
                      onChange={(e) => this.handleChangeValue(e, item.key)} 
                      disabled={disabled} 
                      value={item.value || defaultValue} 
                      required={required}
                      className="form-control" >
                      <option value="">Please select</option>
                      {options && options.map((opt: any) => <option value={opt.value} key={opt.value} disabled={opt.disabled}>{opt.label}</option>)}
                    </select>
                  ) : (
                    <>
                      <input 
                        type="text" 
                        value={item.value || defaultValue} 
                        onChange={(e) => this.handleChangeValue(e, item.key)} 
                        disabled={disabled} 
                        required={required} />
                      {(type === 'percentage' || type === 'price') && (
                        <div>{type === 'percentage' ? '%' : type === 'price' ? selectedCurrencyValue : ''}</div>
                      )}
                    </>
                  )}
                </span>
              </li> 
            );
          })}
        </ol>
      </div>
    );
  }

  private renderTimeDependentPane() {
    const { timePeriods, items } = this.state.pricing;

    console.log('time', timePeriods);

    const selectedCurrency = items.find(i => i.key === 'currency');
    const selectedCurrencyValue = selectedCurrency && selectedCurrency.value.toString() || 'EUR';

    return (
      <div className="pane-time-periods">
        <table className="terms-table">
          <thead>
            <tr>
              <th>Time Periods</th>
              <th></th>
              <th>Sales Factor</th>
              <th>Exchange Rate from EUR</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {timePeriods && timePeriods.map((timePeriod: any, index: number) => (
              <tr key={index}>
                <td style={{width: 220}}>
                  {formatPeriod(timePeriod.dateFrom, timePeriod.dateUntil)}
                </td>
                <td>
                  <button disabled={this.isDisabled} onClick={() => this.handleEditTimePeriodRange(timePeriod)}>
                    <Icon name="calendar-black" />
                  </button>
                </td>
                <td>
                  <span className="pricings-list__price">
                    <input
                      type="text"
                      value={timePeriod.sales_factor || ''}
                      onChange={(e) => this.handleChangeTimePeriod(e, index, 'sales_factor')}
                      className="form-control"
                      placeholder="eg. 190"
                    />
                    <div>%</div>
                  </span>
                </td>
                <td>
                  <span className="pricings-list__price">
                    <input
                      type="text"
                      value={timePeriod.exchange_rate || ''}
                      onChange={(e) => this.handleChangeTimePeriod(e, index, 'exchange_rate')}
                      className="form-control"
                      placeholder="eg. 2.5"
                    />
                    <div>{selectedCurrencyValue}</div>
                  </span>
                </td>
                <td style={{width: 0}}>
                  <button
                    type="button"
                    onClick={() => this.handleDeleteTimePeriod(index)}
                  >
                    <Icon name="delete" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="text-right">
          <button
            type="button"
            className="btn btn-text"
            onClick={this.handleAddTimePeriod}
          >
            + Add Entry
          </button>
        </div>
      </div>
    );
  }

  handleEditTimePeriodRange = (selectedTimePeriod: any) => {
    this.setState({
      isEditingPeriod: true,
      selectedTimePeriod
    });
  }

  handleChangeTimePeriod = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    index: number,
    field: 'range' | 'sales_factor' | 'exchange_rate'
  ) => {
    const { timePeriods } = this.state.pricing;
    const updatedTimePeriods = [...(timePeriods || [])];
    updatedTimePeriods[index][field] = event.target.value;

    this.setState({
      ...this.state,
      pricing: {
        ...this.state.pricing,
        timePeriods: updatedTimePeriods,
      },
      hasChanged: true,
    });
  };

  handleAddTimePeriod = () => {
    const { timePeriods } = this.state.pricing;
    const newEntry = {
      dateFrom: new Date(),
      dateUntil: new Date(),
      sales_factor: '',
      exchange_rate: '',
    } as any;

    this.setState({
      ...this.state,
      pricing: {
        ...this.state.pricing,
        timePeriods: [...(timePeriods || []), newEntry],
      },
      hasChanged: true,
    });
  };

  handleDeleteTimePeriod = (index: number) => {
    const { timePeriods } = this.state.pricing;
    const updatedTimePeriods = [...(timePeriods || [])];
    updatedTimePeriods.splice(index, 1);

    this.setState({
      ...this.state,
      pricing: {
        ...this.state.pricing,
        timePeriods: updatedTimePeriods,
      },
      hasChanged: true,
    });
  };

  private renderTermsAndConditionsPane() {
    const { termLinks } = this.state.pricing;

    return (
      <div className="pane-terms">
        <table className="terms-table">
          <thead>
            <tr>
              <th>Language</th>
              <th>URL</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {termLinks && termLinks.map((term: any, index: number) => (
              <tr key={index}>
                <td style={{width: 200}}>
                  <select
                    value={term.lang || ''}
                    onChange={(e) => this.handleChangeTermLink(e, index, 'lang')}
                    className="form-control"
                  >
                    <option value="">Select Language</option>
                    {availableLanguages.map((l) => {
                      return (
                        <option value={l.code}>{l.name}</option>
                      )
                    })}
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    value={term.url || ''}
                    onChange={(e) => this.handleChangeTermLink(e, index, 'url')}
                    className="form-control"
                    placeholder="eg. https://kwc.com/terms"
                  />
                </td>
                <td style={{width: 0}}>
                  <button
                    type="button"
                    onClick={() => this.handleDeleteTermLink(index)}
                  >
                    <Icon name="delete" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="text-right">
          <button
            type="button"
            className="btn btn-text"
            onClick={this.handleAddTermLink}
          >
            + Add Entry
          </button>
        </div>
      </div>
    );
  }

  handleChangeTermLink = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    index: number,
    field: 'lang' | 'url'
  ) => {
    const { termLinks } = this.state.pricing;
    const updatedTermLinks = [...(termLinks || [])];
    updatedTermLinks[index][field] = event.target.value;

    this.setState({
      ...this.state,
      pricing: {
        ...this.state.pricing,
        termLinks: updatedTermLinks,
      },
      hasChanged: true,
    });
  };

  handleAddTermLink = () => {
    const { termLinks } = this.state.pricing;
    const newEntry = {
      languageCode: '',
      link: '',
    } as any;

    this.setState({
      ...this.state,
      pricing: {
        ...this.state.pricing,
        termLinks: [...(termLinks || []), newEntry],
      },
      hasChanged: true,
    });
  };

  handleDeleteTermLink = (index: number) => {
    const { termLinks } = this.state.pricing;
    const updatedTermLinks = [...(termLinks || [])];
    updatedTermLinks.splice(index, 1);

    this.setState({
      ...this.state,
      pricing: {
        ...this.state.pricing,
        termLinks: updatedTermLinks,
      },
      hasChanged: true,
    });
  };

  handleChangeValue = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, key: string) => {
    let newValue = event.target.value;

    const editedItems = this.state.pricing.items;
    const editedItem = editedItems.find((item: any) => item.key === key) || {type: 'empty', value: 'empty'};

    // if (editedItem.type === 'float') {
    //   newValue = newValue.replace(',', '.');
    //   newValue = newValue.replace(/[^0-9.]/g, '');
    // }

    editedItem.value = newValue;

    this.setState({
      ...this.state, 
      pricing: {
        ...this.state.pricing,
        items: editedItems,
      },
      hasChanged: true
    });
  }

  handleSelect = () => {
    console.log('select');
  }

  handleSave = () => {
    // Validate and format each term link
    const validateAndFormatUrl = (url: string): string => {
      if (!url) return url;
      try {
        const parsedUrl = new URL(url);
        return parsedUrl.href;
      } catch (e) {
        return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
      }
    };

    const validateLang = (lang: string): string => {
      if (!lang || !availableLanguages.some((l) => l.code === lang)) {
        return 'en'; // Default to 'en' if invalid or empty
      }
      return lang;
    };

    const { termLinks } = this.state.pricing;
    const validatedTermLinks = termLinks && termLinks.map((term) => ({
      lang: validateLang(term.lang),
      url: validateAndFormatUrl(term.url),
    }));

    // Update state with validated termLinks
    this.setState(
      {
        pricing: {
          ...this.state.pricing,
          termLinks: validatedTermLinks,
        },
        hasChanged: false, // Reset the 'hasChanged' flag
      },
      () => {
        // Dispatch the save action
        this.props.dispatch(
          requestAPIActions.load<RequestApiHttpPayload>('pricing', {
            url: '/Pricings',
            options: {
              method: 'PATCH',
              data: this.state.pricing,
            },
          })
        );
      }
    );
  };

  // handleDrilledSubmitMarket = (items: any, termLinks: any) => {
  //   this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
  //     'pricings', {
  //       url: `/Pricings/replaceOrCreate?returnAll=true`,
  //       options: {
  //         method: 'POST',
  //         data: {
  //           ...this.state.selectedPricing,
  //           type: this.state.selectedPricing && this.state.selectedPricing.type || this.state.addingType,
  //           items,
  //           termLinks
  //         },
  //       }
  //     },
  //     true
  //   ));
  // }

  private get pricingId(): string | undefined {
    const { match } = this.props;

    return match && match.params && match.params.pricingId;
  }
}

export const PricingsMarket = connect((state: GlobalPrivateState) => ({
  pricing: state.pricing,
  pricings: state.pricings,
  params: state.queryState.params,
}))(PricingsMarketPartial);

export default PricingsMarket;